import { render, staticRenderFns } from "./LicenseBundles.vue?vue&type=template&id=0be8dd28&"
import script from "./LicenseBundles.vue?vue&type=script&lang=js&"
export * from "./LicenseBundles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports